<template>
    <v-row justify="center" align="center" no-gutters>
        <v-col cols="12" xl="6" lg="6" md="8" sm="8">

            <v-row justify="center" no-gutters>
                <span class="text-h6 text-sm-h5 text-center">Finish Your Post</span>
            </v-row>

            <v-form v-model="isFormValid">
                <v-row justify="center" no-gutters class="mt-4">
                    <v-col cols="12" xl="8" lg="8" md="10" sm="10">

                        <v-row justify="center" no-gutters class="mb-4">
                            <v-col cols="12">
                                <v-row justify="center" no-gutters class="mb-2">
                                    <v-radio-group v-model="textPost.type" row dense mandatory hide-details label="Select Audience (required):" @change="checkPostType" class="mt-0 mb-2 mr-n4">
                                        <v-radio label="Public" value="public"></v-radio>
                                        <v-radio label="Group" value="group"></v-radio>
                                    </v-radio-group>
                                </v-row>

                                <v-row v-if="textPost.type == 'public'" justify="center" align="center" no-gutters class="mb-2">
                                    <span class="text-center font-weight-light text-subtitle-2 text-md-subtitle-1">*Your post will be available for everyone to see*</span>
                                </v-row>

                                <v-row v-if="textPost.type == 'group'" justify="center" align="center" no-gutters class="mb-2">

                                    <v-col cols="8" xl="6" lg="6" md="6" sm="6">
                                        <v-autocomplete v-model="textPost.group" :items="userGroups" dense item-text="groupName" item-value="groupId" persistent-hint hint="Select a group from your groups" return-object no-data-text="No Groups to Select"></v-autocomplete>  
                                    </v-col>

                                    <v-col cols="2" class="hidden-sm-and-up">
                                        <v-btn small depressed rounded color="primary" @click.stop="newGroupDialog = true">
                                            <v-icon>mdi-account-multiple-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                        
                                    <v-col cols="2" align="center" class="hidden-xs-only">
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on }">
                                                <v-btn v-on="on" small fab raised top left @click.stop="newGroupDialog = true" rounded color="primary">
                                                    <v-icon>mdi-account-multiple-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Create a New Group</span>
                                        </v-tooltip>
                                    </v-col>

                                    <NewGroup v-if="newGroupDialog" :dialog="newGroupDialog" @cancelNewGroup="newGroupDialog = false"/>

                                </v-row>
                            </v-col>
                        </v-row>

                        <v-text-field v-model="textPost.title" clearable required flat dense outlined :rules="titleRules" :counter="50" label="Enter Title (required)"></v-text-field>
                        <v-textarea v-model="textPost.description" flat outlined dense clearable required no-resize :counter="750" :rules="descriptionRules" label="Enter Description (required)"></v-textarea>
                        <!-- <v-text-field v-model="textPost.videoLanguageSelected" :rules="languageRules" outlined clearable required flat dense label="Enter the language spoken in the uploaded Video, Audio or Youtube URL"></v-text-field> -->
                        <v-file-input v-model="textPost.thumbnail" ref="imageFileInput" :rules="thumbnailRules" :show-size="true" accept="image/*" flat dense outlined prepend-icon="" single-line append-icon="mdi-camera" type="file" label="Click to upload a thumbnail (optional)" @change="setPreviewImage()" @click:clear="blurFileInput"></v-file-input>



                        <!-- IMAGE PREVIEW -->
                        <v-row justify="center" no-gutters class="mb-2">
                            <!-- USER IMAGE -->
                            <v-col v-if="showPreviewImage" cols="10" xl="6" lg="6" md="8" sm="8" align="center" class="pt-0" style="position: relative;">
                                <v-icon class="red--text text--darken-1 mt-4 ml-n2" style="z-index: 1; position: absolute; top: 0; left:0;" @click="clearPreviewImage()">mdi-close-circle</v-icon>
                                <span class="text-caption text-center">Thumbnail Preview</span>
                                <transition enter-active-class="slideDown" leave-active-class="slideUp"  appear>
                                    <v-img class="rounded-lg border--primary" contain height="140" :src="previewImage">

                                    </v-img>
                                </transition>
                            </v-col>
                            <!-- AUTO GENERATED IMAGE && NO THUMBNAIL IMAGE -->
                            <v-col v-else-if="showAutoGeneratedImage" cols="10" xl="6" lg="6" md="8" sm="8" align="center" class="pt-0">
                                <!-- v-if="mediaSelectionStep.textFileUploadSelected && !isIOS && !textOnly" -->
                                <span class="text-caption text-center cursor--pointer" @click="getRandomlySavedThumbnail()">Generated Thumbnail 
                                    <v-icon small color="primary">mdi-reload</v-icon>
                                </span>
                                <!-- <span v-else class="text-caption text-center">Generated Thumbnail</span> -->
                                <transition enter-active-class="slideDown" leave-active-class="slideUp" appear>
                                    <v-img crossorigin="anonymous" class="rounded-lg border--primary" contain height="140" ref="autoGeneratedImage" :src="autoGeneratedImage"></v-img>
                                </transition>
                            </v-col>

                        </v-row>

                        <v-text-field v-model="tag" flat dense outlined counter="15" label="Enter Tags (optional)" :rules="tagRules" @keypress.enter="addTag" @keypress.space="addTag"></v-text-field>
                        <v-divider v-if="textPost.tags.length >= 1" class="my-1"/>
                        <span v-if="textPost.tags.length >= 1">Added Tags:</span><br/>
                        <v-row v-if="textPost.tags.length >= 1" class="ma-0 pa-0">
                            <v-col cols="12">
                                <v-chip close pill v-for="(tag) in textPost.tags" :key="tag" color="primary" @click:close="removeChip(tag)" class="mx-1">{{ tag }}</v-chip>
                            </v-col>
                        </v-row>

                        <v-divider v-if="suggestedTags.length >= 1" class="my-1"/>
                        <span v-if="suggestedTags.length >= 1">Suggested Tags:</span><br/>
                        <v-row v-if="suggestedTags.length >= 1" class="ma-0 pa-0">
                            <v-col cols="12">
                                <v-chip close close-icon="mdi-plus"  v-for="(t, i) in suggestedTags" :key="i" color="primary"  @click:close="addSuggestedChip(t,i)" class="mx-1">{{ t }}</v-chip>
                            </v-col>
                        </v-row>
                        <!-- <v-divider class="my-2"/> -->
                        <!-- <v-chip close pill v-for="(tag) in textPost.tags" :key="tag" color="primary" @click:close="removeChip(tag)" class="mx-1">{{ tag }}</v-chip> -->
                    </v-col>
                </v-row>
            </v-form>
        </v-col>
    </v-row>
</template>
<script>
import NewGroup from "../../components/Groups/NewGroup.vue";
export default {
    name: 'PostContentMetadata',
    props: ["isDraftPost", "draftPost"],
    components: {
        NewGroup
    },
    data(){
        return {
            isFormValid: true,
            titleRules: [(v) => !!v || "Title is required", (v) => (v && v.length <= 50) || "Title must be 50 characters or less",],
            descriptionRules: [(v) => !!v || "Description is required", (v) => (v && v.length <= 750) || "Description must be 750 characters or less",],
            languageRules: [(v) => !!v || "Language Name is required", (v) => (v && v.length <= 50) || "Langugage name must be 30 characters or less",],
            tagRules: [(v) => (v.length <= 15) || "Tag must be 15 characters or less",],
            thumbnailRules: [
                (value) => !value ||
                value.size < this.thumbnailFileLimit ||
                "Thumbnail Must be less than 6 MB",
            ],
            thumbnailFileLimit: 6000000, // 6MB
            tag: "",
            suggestedTags: ["#tawq.in", "#translation", "#community",],
            // suggestedTags: [], // right now these are hard coded to come from this array, but can easily be updated to pull from somewhere else, or even the database.
            previewImage: null, // preview image is used to show any * USER SELECTED * files - can be cleared and will default back to an auto generated image
            showPreviewImage: false,
            showAutoGeneratedImage: true,
            autoGeneratedImage: null, // auto gen image is used to show all * AUTO GENERATED * images - cannot be cleared, can only be overwritten by a user selected image
            newGroupDialog: false,
            // RANDOM THUMBNAIL STUFF
            showThumbnailButton: false,
            thumbnailVideo: document.createElement("video"),
            textOnly: false,
        }
    },
    methods: {
        checkPostType: function(type){
            this.textPost.type = type;
            if (type === 'public') {
                this.textPost.group = "";
                // this.textPost.groupLanguage = null;
            }
        },
        blurFileInput(){
            this.$refs.imageFileInput.blur();
        },
        getRandomlySavedThumbnail: function () {
            // console.log("getRandomlySavedThumbnail");
            const randomNum = Math.floor(Math.random() * 6) + 1; // get a random number between 1 and the number of text only images for thumbnail
            this.textPost.thumbnail = null;
            this.textPost.randomThumbnailNumber = randomNum;
            this.textOnly = true;
            if (!this.showAutoGeneratedImage) this.showAutoGeneratedImage = true;
            switch (randomNum) {
                case 1:
                    return this.autoGeneratedImage = require('../../assets/text-only.png');
                case 2:
                    return this.autoGeneratedImage = require('../../assets/tawqin-dictionary.png');
                case 3:
                    // return this.autoGeneratedImage = require('../../assets/learn-new-language.png');
                    return this.autoGeneratedImage = (this.textPost.languageSelected.text.includes("Arabic") ? require('../../assets/arabic-learn-new-language.png') : require('../../assets/learn-new-language.png'));
                case 4:
                    return this.autoGeneratedImage = require('../../assets/empower-voices.png');
                case 5:
                    return this.autoGeneratedImage = require('../../assets/story-culture.png');
                case 6:
                    return this.autoGeneratedImage = require('../../assets/create-caption-connect.png');
                default:
                    return this.autoGeneratedImage = require('../../assets/text-only.png');
            };
        },
        clearPreviewImage(){ // this method is used to clear the preview image and go to the auto generated imaged.
            if (this.isDraftPost && (this.draftPost.thumbnail != null && this.draftPost.thumbnail != "") && this.draftPost.thumbnail == this.previewImage ) { // user has selected to remove the thumbnail associated with their draft post
                this.$emit('setDeleteDraftPostThumbnail', true); // set this value to true so during the save process we can delete what is stored in the database and upload the new thumbnail
                this.showPreviewImage = false;
                this.previewImage = null;
                this.textPost.thumbnail = null;
            } else {
                this.showPreviewImage = false;
                this.previewImage = null;
                this.getRandomlySavedThumbnail();
                // this.textPost.thumbnail = null
                // this.textOnly = true;
                // this.autoGeneratedImage = require('../../assets/text-only.png');
                // this.showAutoGeneratedImage = true;
                // this.textPost.thumbnail = null;
                // this.setAutoGeneratedImage();
            }
        },
        readPreviewImage(){ // readPreviewImage() method is used to take the user selected image (of type file) and display it
            var reader = new FileReader();
            reader.onloadend = () => {
                this.previewImage = reader.result;
                reader = null;
            }
            reader.readAsDataURL(this.textPost.thumbnail);
        },
        setPreviewImage(){
            // console.log("setPreviewImage");
            // determine whether it is a draft post or new post
            if (this.isDraftPost) {
                // console.log("this.isDraftPost");
                // if it is a draft post and has an image
                if (this.draftPost.thumbnail != null && this.draftPost.thumbnail != "") {
                    // draft post, and has an image associated with it already
                    // if there is no user selected image
                    if (typeof this.textPost.thumbnail == 'undefined' || this.textPost.thumbnail == null){
                        this.showPreviewImage = true;
                        this.previewImage = this.draftPost.thumbnail;
                        return;
                    }
                } else {
                    // this.setAutoGeneratedImage();
                    this.getRandomlySavedThumbnail();
                }
                return;
            } else {
                // console.log("ELSE");
                if (typeof this.textPost.thumbnail != 'undefined' && this.textPost.thumbnail != null) {
                    // console.log("this.textPost.thumbnail != null && this.textPost.thumbnail != null");
                    this.readPreviewImage();
                    this.showPreviewImage = true;
                    this.showAutoGeneratedImage = false;
                    this.autoGeneratedImage = null;
                } else {
                    this.getRandomlySavedThumbnail();
                    // this.textPost.thumbnail = null
                    // this.textOnly = true;
                    // this.autoGeneratedImage = require('../../assets/text-only.png');
                    // console.log("calling setAutoGeneratedImage()");
                    // this.setAutoGeneratedImage();
                }
            }
            // determine if it is a youtube video or file upload
            // if (this.mediaSelectionStep.youtubeUrlSelected) {
            //     // if a user has selected an image, preview it.
            //     if (typeof this.textPost.thumbnail != 'undefined' && this.textPost.thumbnail != null) {
            //         this.readPreviewImage();
            //         this.showPreviewImage = true;
            //         this.showAutoGeneratedImage = false;
            //         this.autoGeneratedImage = null;
            //     } else {
            //         this.setAutoGeneratedImage();
            //     }

            // } else if (this.mediaSelectionStep.fileSelected){
            //     // if a user has selected a file to upload, preview it
            //     if(typeof this.textPost.thumbnail != 'undefined' && this.textPost.thumbnail != null){
            //         this.readPreviewImage();
            //         this.showPreviewImage = true;
            //         this.showAutoGeneratedImage = false;
            //         this.autoGeneratedImage = null;
            //     } else {
            //         // else auto generate one
            //         this.setAutoGeneratedImage();
            //     }
            // }
        },
        async setAutoGeneratedImage(){
            console.log("setAutoGeneratedImage: ", this.mediaSelectionStep);
            // this method will be ran when the user hasn't selected an image to be used with their post and we need to auto generate one, and anytime that the file input is cleared.
            this.showPreviewImage = false;
            this.previewImage = null;
            if (this.autoGeneratedImage != null) { // we have already generated the auto generated image. therefore just return!
                console.log("this.autoGeneratedImage != null");
                if(this.mediaSelectionStep.textFileUploadSelected){ // if it is a file upload though we just need to redraw the canvas...
                    console.log("this.mediaSelectionStep.textFileUploadSelected -- loadRandomFrame()");
                    // this.loadRandomFrame();
                }
                this.showAutoGeneratedImage = true;
                return;
            }
            if (!this.mediaSelectionStep.complete) {
                console.log("!this.mediaSelectionStep.complete");
                // Check if there has been a video (we may have this step as the first step again....)
                this.showAutoGeneratedImage = true;
                this.autoGeneratedImage = require('../../assets/no-thumbnail.png');
                return;
            } else if (this.mediaSelectionStep.complete && this.mediaSelectionStep.manualTextInputSelected) {
                console.log("this.mediaSelectionStep.complete && this.mediaSelectionStep.manualTextInputSelected");
                // if there is a video : if youtube show the thumbnail with the youtube video. if it is a file upload, randomly select a frame to begin with
                this.autoGeneratedImage = this.getYoutubeThumbnail();
                this.showAutoGeneratedImage = true;
                return;
            } else if (this.mediaSelectionStep.complete && this.mediaSelectionStep.textFileUploadSelected) {
                console.log("this.mediaSelectionStep.complete && this.mediaSelectionStep.textFileUploadSelected");
                if(this.isIOS && !this.textOnly){  // if the user is using an ios device context.drawImage() doesn't work
                    console.log("this.isIOS && !this.textOnly");
                    this.autoGeneratedImage = require('../../assets/no-thumbnail.png');
                    this.showAutoGeneratedImage = true;
                }  else {
                    // file selected in auto generate image, and not an IOS Device. loading a random one!
                    // generate a random thumbnail from the video selected.
                    console.log("!this.isIOS && this.textOnly");
                    if (this.textPost.video.type.split("/")[0] === "video"){
                        console.log("this.textPost.video.type.split(\"/\")[0] === \"video\"");
                        // this.loadRandomFrame();
                        this.showAutoGeneratedImage = true;
                        return;
                    } else {
                        console.log("else set to audio only jpeg");
                        this.autoGeneratedImage = require('../../assets/text-only.png');
                        this.showAutoGeneratedImage = true;
                        return;
                    }
                }
            }
        },
        loadRandomFrame: function () {
            if(!isNaN(this.thumbnailVideo.duration)) {
                var rand = Math.round(Math.random() * this.thumbnailVideo.duration * 1000) + 1;
                this.thumbnailVideo.currentTime = rand / 1000; // this will "seek" the video and call generateRandomThumbnailFromVideo()
            }
        },
        generateRandomThumbnailFromVideo(){
            return new Promise((resolve) => {
                let canvas = document.createElement("canvas");
                let context = canvas.getContext('2d');
                let videoHeight = this.thumbnailVideo.videoHeight;
                let videoWidth = this.thumbnailVideo.videoWidth;
                canvas.width = videoWidth;
                canvas.height = videoHeight;
                
                context.drawImage(this.thumbnailVideo, 0, 0, videoWidth, videoHeight);
                this.autoGeneratedImage = canvas.toDataURL(); // this sets the auto generated image preview
                // below will create a file of the random image in the case that the user decides to use the random image to upload with their post
                context.canvas.toBlob((blob) => {
                    // this.autoGeneratedImage = blob;
                    this.textPost.thumbnail = new File([blob], "rand_thumbnail", {
                        type: 'image/jpeg',
                        lastModified: Date.now()
                    });
                    resolve();
                }, 'image/jpeg', 1);
            });
        },
        getYoutubeThumbnail(){
            console.log("getYoutubeThumbnail");
            // if (this.mediaSelectionStep.manualTextInputSelected) {
            //     if (typeof this.textPost.videoUrl.split('v=')[1] != 'undefined') {
            //         const videoId = this.textPost.videoUrl.split('v=')[1].split('&ab_channel')[0];
            //         const youtube_static_url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
            //         return youtube_static_url;
            //     } else if (typeof this.textPost.videoUrl.split('be/')[1] != 'undefined') {
            //         const videoId = this.textPost.videoUrl.split('be/')[1];
            //         const youtube_static_url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
            //         return youtube_static_url;
            //     } else if (typeof this.textPost.videoUrl.split('embed/')[1] != 'undefined') {
            //         const videoId = this.textPost.videoUrl.split('embed/')[1];
            //         const youtube_static_url = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
            //         return youtube_static_url;
            //     } else {
            //         return require('../../assets/no-thumbnail.png');
            //     }
            // } else {
            //     return require('../../assets/no-thumbnail.png');
            // }
        },
        addTag: function () {
            if(this.tag != "" && this.tag.length <= 15 && !this.textPost.tags.includes("#" + this.tag) && this.textPost.tags.length < 9) {
                if(this.tag.startsWith(" ")){
                    this.tag = this.tag.split(" ")[1];
                }
                if(this.tag.startsWith("#")){
                    this.textPost.tags.push(this.tag);
                } 
                else {
                    this.textPost.tags.push("#" + this.tag);
                }
                this.tag = "";
            }
        },
        addSuggestedChip: function (tag, index) {
            if (!this.textPost.tags.includes(tag) && this.textPost.tags.length < 9) {
                this.textPost.tags.push(tag);
                this.suggestedTags.splice(index, 1);
            } else if (this.textPost.tags.includes(tag) && !this.textPost.tags.length < 9) {
                this.suggestedTags.splice(index, 1);
            } // else do nothing
        },
        removeChip: function (tag) {
            this.textPost.tags.splice(this.textPost.tags.indexOf(tag), 1);
        },
    },
    watch:{
        isFormValid(newValue){
            if(newValue){
                this.$store.commit('newTextPost/saveContentMetadataStep', { complete: true });
            }
            else {
                this.$store.commit('newTextPost/saveContentMetadataStep', { complete: false });
            }
        }
    },
    computed: {
        textPost: {
            get(){
                return this.$store.state.newTextPost.textPost;
            },
            set(value){
                this.$store.commit('newTextPost/saveTextPost', value);
            }
        },
        mediaSelectionStep(){
            return this.$store.state.newTextPost.mediaSelectionStep;
        },
        userGroups(){
            return this.$store.state.userGroups;
        },
        isIOS(){
            return this.$store.state.isIOSDevice;
        },
    },
    beforeDestroy(){
        this.$store.commit('newTextPost/saveContentMetadataStep', { complete: true });
    },
    mounted: function(){
        if(this.isDraftPost && this.isFormValid){
            this.$store.commit('newTextPost/saveContentMetadataStep', { complete: true });
        }
    },
    created: function() {
        this.getRandomlySavedThumbnail();
        // this.textPost.thumbnail = null;
        // this.textOnly = true;
        // this.autoGeneratedImage = require('../../assets/text-only.png');
        // if (this.mediaSelectionStep.textFileUploadSelected) {
        //     console.log("CREATED -- this.mediaSelectionStep.textFileUploadSelected");
        //     this.textPost.thumbnail = null
        //     this.textOnly = true;
        //     this.autoGeneratedImage = require('../../assets/text-only.png');
        // } else {
        //     this.setPreviewImage();
        // }
    },
}
</script>